import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getDishesAPI = (
  search: any,
  page: any,
  limit: any,
  selectedStatus: any,
  sortField: any,
  sortDirection: any,
  created_by: any
) => {
  return Http.get(
    `dish?page=${page}&limit=${limit}&sort_by=${sortField}&sort_direction=${sortDirection}&search=${search}&status=${selectedStatus}&created_by=${created_by}`
  );
};
export const getCusineMasterAPI = () => {
  return Http.get("master/get-cuisines");
};
export const addDishesAPI = (data: any) => {
  return Http.post(ApiRoutes.addDishes, data);
};
export const getDishesDetailsAPI = (id: any) => {
  return Http.get(`dish/${id}`);
};
export const editDishesAPI = (id:any,data:any) => {
  return Http.put(`dish/${id}`,data);
};
export const deleteDishesAPI = (id:any) => {
  return Http.delete(`dish/${id}`);
};
export const deleteBookingAPI = (id:any) => {
  return Http.delete(`booking/${id}`);
};
export const deleteGroceryAPI = (id:any) => {
  return Http.delete(`grocery/remove-grocery/${id}`);
};

export const searchDishesAPI = (search:any) => {
  return Http.get(`dish/only-grocery?search=${search}`);
};
export const searchDishesGroceryAPI = (id:any) => {
  return Http.get(`dish/only-grocery/${id}`);
};
export const getUpdateDishesStatusAPI = (id:any,data: any) => {
  return Http.put(`dish/status/${id}`, data);
};
